<template>
  <q-form-item
    :label="element.caption"
    :prop="element.key"
  >
    <q-form-generator
      v-model="model[element.key]"
      :form-structure="formStructure"
    />
  </q-form-item>
</template>

<script>
  import elementGeneratorMixin from "./elementGeneratorMixin";

  export default {
    name: "CompositeModelItem",
    mixins: [elementGeneratorMixin],

    data(){
      return {
        formStructure: {}
      }
    },

    mounted() {
      this.$delegate('structure', 'fetchFormStructure', {
        structureKey: this.element.formStructureKey
      }).then((response) => {
        this.formStructure = response.result;
      }).catch(() => {
      });
    }
  }
</script>

<style scoped>

</style>